<z-modal [open]="true" *ngIf="essentialData$ | async as essentialObject" [autoWidth]="true">
    <ng-container footer>
        <a (click)="close.emit()" class="btn cancel leading-12 rounded text-center px-10">{{"btn_cancel"|
            translate:essentialObject.language:ModuleNames.Shared}}</a>
        <i (click)="exportData(essentialObject.language)"
            class="far fa-download btn cancel leading-12 w-12 rounded text-center"></i>
    </ng-container>
    <ng-container body>
        <div class="max-h-screen-90 block bg-white innerListScroll w-export portrait" id="single-chart-export">
            <div class="innerPage block relative px-10 bg-white pt-20">
                <div [ngClass]="{'border border-zen border-opacity-10':!data.customBorders}" class="block "
                    [innerHtml]="data.chartHTML.outerHTML | safe:'html'"></div>

                <filter-exports-page [language]="essentialObject.language"
                    [applyGlobalFilters]="true" [seperatePage]="false"></filter-exports-page>
            </div>

            <div class="header w-full px-10 flex flex-row items-start justify-between">
                <h5 class="text-3xs text-zen text-opacity-60">{{reportName
                    |translate:essentialObject.language:ModuleNames.Shared }}</h5>
                <h5 class="text-3xs text-zen "><span class="text-opacity-60">{{
                        "txtPreparedFor"|translate:essentialObject.language:ModuleNames.Shared }}
                    </span> <span class="text-zen font-medium">{{essentialObject.selectedEntity.name |
                        extract:essentialObject.language}}</span> </h5>
            </div>
            <div class="footer w-full px-10 flex flex-row items-end justify-between ">
                <div class="flex flex-col gap-1">
                    <img class="h-8 w-auto object-cover" src="assets/img/logo.png" alt="">
                </div>
                <div class="flex flex-col items-end gap-1">
                    <h5 class="text-3xs text-zen text-opacity-60">
                        {{ "txtGenerated"|translate:essentialObject.language:ModuleNames.Shared }}: {{date | date:
                        'dd/MM/yyyy'}}
                    </h5>
                    <h5 class="text-3xs text-zen text-opacity-60">
                        {{ "txtAllRights"|translate:essentialObject.language:ModuleNames.Shared }} © {{date | date: 'yyyy'}}
                        -
                        www.zenithr.com</h5>

                </div>
            </div>


        </div>
    </ng-container>
</z-modal>